import {
    Routes,
    Route,
} from "react-router-dom";
import HomePage from './pages/home/HomePage';
import CurrentLunchPage from "./pages/currentLunch/CurrentLunchPage";
import CreateLunchPage from "./pages/createLunch/CreateLunchPage";
import TemplatesPage from "./pages/templates/TemplatesPage";
import CreateTemplatePage from "./pages/createTemplate/CreateTemplatePage";
import NotFoundPage from "./pages/notFound/NotFoundPage";

const MainRouting = () => (
    <Routes>
        <Route path='/' element={<HomePage/>}/>
        <Route path='/latest-lunch' element={<CurrentLunchPage/>}/>
        <Route path='/create-lunch' element={<CreateLunchPage/>}/>
        <Route path='/templates' element={<TemplatesPage/>}/>
        <Route path='/template' element={<CreateTemplatePage/>}/>
        <Route path="*" element={<NotFoundPage/>}/>
    </Routes>
);

export default MainRouting;